export const REFRESH_VIEW = 'IMP/REFRESH_VIEW';

export const refreshView = () => ({
  type: REFRESH_VIEW,
});
